<section class="accordion" @fadeIn>

</section>
